import React, { useEffect, useRef } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { DefaultModal, SimpleCheckboxBase } from '@/presentation/components';
import InputKV from '../../components/input-kv';
import ButtonKV from '../../components/button-kv';
import { ELEMENTARY, HIHG_SCHOOL, MIDDLE_SCHOOL } from '@/presentation/constants/class-grades';
import { modalEditTeacherState } from '../atoms';
import Styles from '../../styles/steps-styles.scss';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { Select } from '../../components';
import { USER_TITLES } from '@/presentation/constants/user-titles';
const buildCheckBox = (label, key, defaultChecked) => {
    return (React.createElement("div", { className: Styles.checkboxWrap, key: key },
        React.createElement("div", { style: { padding: '0.2rem' } },
            React.createElement(SimpleCheckboxBase, { name: `check-${label}`, defaultChecked: defaultChecked })),
        React.createElement("div", { className: Styles.text }, label)));
};
const isThisChecked = (label, gradesString) => {
    try {
        const grades = gradesString.split(',');
        return grades.includes(label);
    }
    catch (error) {
        return false;
    }
};
const ModalEdit = ({ editData, toggleModalEdit, modalEditTeacher, validation, doEditRecord }) => {
    var _a, _b, _c;
    const [state, setState] = useRecoilState(modalEditTeacherState);
    const resetState = useResetRecoilState(modalEditTeacherState);
    const { showCustomError } = useCustomToast({ containerId: 'ModalUploadTeachers' });
    const formRef = useRef();
    const validate = (field) => {
        const { email, firstName, lastName } = state;
        const formData = { email, firstName, lastName };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.emailError || !!prev.firstNameError || !!prev.lastNameError })));
    };
    useEffect(() => {
        if (state.firstName)
            validate('firstName');
    }, [state.firstName]);
    useEffect(() => {
        if (state.lastName)
            validate('lastName');
    }, [state.lastName]);
    useEffect(() => {
        if (state.email)
            validate('email');
    }, [state.email]);
    useEffect(() => {
        // resetState();
        console.log('-->', editData === null || editData === void 0 ? void 0 : editData.record);
        setState(prev => {
            var _a, _b, _c, _d, _e, _f;
            return (Object.assign(Object.assign({}, prev), { email: (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.email, firstName: (_b = editData === null || editData === void 0 ? void 0 : editData.record) === null || _b === void 0 ? void 0 : _b.firstName, lastName: (_c = editData === null || editData === void 0 ? void 0 : editData.record) === null || _c === void 0 ? void 0 : _c.lastName, title: ((_d = editData === null || editData === void 0 ? void 0 : editData.record) === null || _d === void 0 ? void 0 : _d.title) ? { value: (_e = editData === null || editData === void 0 ? void 0 : editData.record) === null || _e === void 0 ? void 0 : _e.title, label: (_f = editData === null || editData === void 0 ? void 0 : editData.record) === null || _f === void 0 ? void 0 : _f.title } : null }));
        });
    }, [editData]);
    const closeModal = () => {
        toggleModalEdit(false);
        resetState();
    };
    const updateRecord = () => {
        var _a;
        // console.log(state.email, state.firstName, state.lastName);
        const grades = getGradeFromForm(formRef);
        if (grades.length > 0) {
            doEditRecord({
                email: state.email,
                firstName: state.firstName,
                lastName: state.lastName,
                grades: grades.join(','),
                title: (_a = state === null || state === void 0 ? void 0 : state.title) === null || _a === void 0 ? void 0 : _a.value
            }, editData);
        }
        else {
            showCustomError('Error', 'Please select at least one GRADE option');
        }
    };
    return (React.createElement(DefaultModal, { height: "90", hUnit: "vh", width: "80", wUnit: "vw", open: modalEditTeacher, onClose: closeModal, showClose: true, overlayCustomStyles: { zIndex: 10000 } },
        React.createElement("form", { method: "post", className: Styles.editModalWrap, ref: formRef },
            React.createElement("h1", null, "Edit teacher"),
            React.createElement("div", { className: Styles.subtitle }, "Teacher Information"),
            React.createElement("div", { className: Styles.namesWrap },
                React.createElement("div", { className: Styles.inputWrapLeft },
                    React.createElement("div", { className: Styles.select },
                        React.createElement(Select, { name: "title", label: "TITLE", state: state, setState: setState, placeholder: 'ie. Mr.', options: USER_TITLES.map(item => ({
                                value: `${item}`,
                                label: `${item}`
                            })) }))),
                React.createElement("div", { className: Styles.inputWrapLeft },
                    React.createElement(InputKV, { type: "text", name: "firstName", placeholder: "ie. Guy", label: "FIRST NAME", required: true, defaultValue: (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.firstName, stateParam: modalEditTeacherState })),
                React.createElement("div", { className: Styles.inputWrapRight },
                    React.createElement(InputKV, { type: "text", name: "lastName", placeholder: "ie. Green", label: "LAST NAME", required: true, defaultValue: (_b = editData === null || editData === void 0 ? void 0 : editData.record) === null || _b === void 0 ? void 0 : _b.lastName, stateParam: modalEditTeacherState }))),
            React.createElement("div", { className: Styles.emailWrap },
                React.createElement(InputKV, { type: "email", name: "email", placeholder: "ie. hawkins@mail.com", label: "EMAIL", required: true, defaultValue: (_c = editData === null || editData === void 0 ? void 0 : editData.record) === null || _c === void 0 ? void 0 : _c.email, stateParam: modalEditTeacherState })),
            React.createElement("div", { className: Styles.detailWrap },
                React.createElement("div", { className: Styles.title }, "What class grades does this teacher teach?"),
                React.createElement("div", { className: Styles.subtitle }, "please select at least one option")),
            React.createElement("div", { className: Styles.gradeWrap },
                React.createElement("div", null,
                    React.createElement("div", { className: Styles.title }, "Elementary"),
                    ELEMENTARY.map((item, key) => { var _a; return buildCheckBox(item, key, isThisChecked(item, (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.classGrade)); })),
                React.createElement("div", null,
                    React.createElement("div", { className: Styles.title }, "Middle School"),
                    MIDDLE_SCHOOL.map((item, key) => { var _a; return buildCheckBox(item, key, isThisChecked(item, (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.classGrade)); })),
                React.createElement("div", null,
                    React.createElement("div", { className: Styles.title }, "High School"),
                    HIHG_SCHOOL.map((item, key) => { var _a; return buildCheckBox(item, key, isThisChecked(item, (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.classGrade)); }))),
            React.createElement("div", { className: Styles.btnWrap },
                React.createElement(ButtonKV, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: updateRecord, testId: "btn-save-record", stateParam: modalEditTeacherState }, "Confirm")))));
};
export default ModalEdit;
const getGradeFromForm = (formRef) => {
    var _a, _b;
    const list = [];
    const elements = formRef.current.elements;
    for (let i = 0; i < elements.length; i++) {
        if ((_b = (_a = elements[i]) === null || _a === void 0 ? void 0 : _a.getAttribute('name')) === null || _b === void 0 ? void 0 : _b.startsWith('check-')) {
            const checkbox = elements[i];
            if (checkbox.checked) {
                // console.log(checkbox.name);
                list.push(checkbox.name.replace('check-', ''));
            }
        }
    }
    return list;
};
